import * as styled from '../styles';
import { MONTHLY_PRICE_CENTS, MONTH_OPTIONS } from '../constants';
import { formatPrice } from '../helpers';

type Props = {
  months: number;
  isLoading: boolean;
  error: string | null;
  provider: Account.FoundProvider;
  onMonthsChange: (value: number) => void;
  onPay: () => void;
};

export const ConfirmStep = ({
  months,
  isLoading,
  error,
  provider,
  onMonthsChange,
  onPay,
}: Props) => {
  const total = MONTHLY_PRICE_CENTS * months;

  return (
    <>
      <styled.Heading>Choose plan</styled.Heading>
      <styled.VerifiedBanner>
        <styled.VerifiedTick>✓</styled.VerifiedTick>
        <div>
          <styled.VerifiedLabel>Verified account</styled.VerifiedLabel>
          <styled.VerifiedName>
            {provider.first_name} {provider.last_name}
          </styled.VerifiedName>
        </div>
      </styled.VerifiedBanner>

      <styled.Card>
        <styled.Label>Duration</styled.Label>
        <styled.MonthsGrid>
          {MONTH_OPTIONS.map((option) => (
            <styled.MonthOption
              key={option.months}
              $selected={months === option.months}
              onClick={() => onMonthsChange(option.months)}
            >
              <styled.MonthLabel $selected={months === option.months}>
                {option.label}
              </styled.MonthLabel>
              <styled.MonthPrice $selected={months === option.months}>
                {formatPrice(MONTHLY_PRICE_CENTS * option.months)}
              </styled.MonthPrice>
            </styled.MonthOption>
          ))}
        </styled.MonthsGrid>

        <styled.Divider />

        <styled.PriceRow>
          <styled.PriceLabel>
            {formatPrice(MONTHLY_PRICE_CENTS)} × {months}
          </styled.PriceLabel>
          <styled.PriceValue>{formatPrice(total)}</styled.PriceValue>
        </styled.PriceRow>
        <styled.PriceRow>
          <styled.TotalLabel>Total</styled.TotalLabel>
          <styled.TotalValue>{formatPrice(total)}</styled.TotalValue>
        </styled.PriceRow>

        <styled.Button disabled={isLoading} onClick={onPay}>
          {isLoading ? 'Redirecting to payment...' : 'Pay Now'}
        </styled.Button>

        {error && <styled.ErrorText>{error}</styled.ErrorText>}

        <styled.PaymentMethods>
          <styled.PaymentBadge>Card</styled.PaymentBadge>
          <styled.PaymentBadge>MTN MoMo</styled.PaymentBadge>
          <styled.PaymentBadge>M-Pesa</styled.PaymentBadge>
          <styled.PaymentBadge>USSD</styled.PaymentBadge>
          <styled.PaymentBadge>Bank Transfer</styled.PaymentBadge>
        </styled.PaymentMethods>
      </styled.Card>
    </>
  );
};
